import dayjs from 'dayjs';

const MIN_GPU_CHART_RANGE_DAYS = 2;

export const isGpuDateRangeSupported = (from: string, to: string): boolean =>
  dayjs(to).diff(dayjs(from), 'day', true) >= MIN_GPU_CHART_RANGE_DAYS;
